import Axios from 'axios'
import { rootUrl, apiUrl } from './App'

export async function getBrowserId() {
    let browserId = await localStorage.getItem("browser_id");

    if (!browserId) {
        browserId = window.crypto?.randomUUID ? window.crypto.randomUUID() : Math.random().toString(36).substring(2) + Date.now().toString(36);
        localStorage.setItem("browser_id", browserId);
    }

    return browserId;
}

export const Http = Axios.create({
    baseURL: rootUrl
})

export const HttpAuth = Axios.create({
    baseURL: apiUrl
})

Http.interceptors.request.use(
    async (config) => {
        const browserId = await getBrowserId();

        config.headers["x-browser-id"] = browserId;

        return config;
    }
)

HttpAuth.interceptors.request.use(
    async (config) => {
        const token = await localStorage.getItem("access_token");
        const browserId = await getBrowserId();

        const bs_2fa = localStorage.getItem('data-bs-2fa')

        if(bs_2fa === 'false') {
            if(config.url !== '/app' && config.method === 'get') {
                window.location.replace('/secure')
            }
        }

        if (token) {
            config.headers.authorization = `Bearer ${token}`;
        }

        config.headers["x-browser-id"] = browserId;

        return config;
    }
)

HttpAuth.interceptors.response.use(response => {
    return response;
}, error => {
    
    if(error.response) {
        if(error.response.status === 401) {
            if(error.response.data.error_code !== undefined) {
                window.location.replace('/2fa/method')
            }else {
                localStorage.removeItem('access_token');
                window.location.replace('/login')
            }
        }
    }
    return Promise.reject(error);
})

export const HttpUpload = Axios.create({
    baseURL: apiUrl
})

HttpUpload.interceptors.request.use(
    async (config) => {
        const browserId = await getBrowserId();
        config.headers.authorization = 'Bearer ' + await localStorage.getItem('access_token')
        config.headers["Content-Type"] = "multipart/form-data"
        config.headers["x-browser-id"] = browserId
        return config;
    }
)